'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    $(document).on('click', '.dataTable[id=orderItems] [data-cancel-order-item], .dataTable[id=orderItemsProcessing] [data-cancel-order-item]', function (e) {
        e.preventDefault();
        var orderItemId = $(this).attr("data-cancel-order-item");
        var table = $(this).closest('.dataTable');
        var msgTxt = Resx.App.CancelOrderItemConfirmMessage.replace("{0}", $(this).attr("data-cancel-order-item-name")).replace("{1}", $(this).attr("data-cancel-order-item-amount"));
        _message2.default.confirm(msgTxt, Resx.App.CancelOrderItemConfirmTitle, function (isConfirmed) {
            if (isConfirmed) {
                if (table.length > 0) {
                    var api = table.DataTable();
                    console.log(orderItemId);
                    orderService.cancelOrderItem(orderItemId).done(function (result) {
                        api.ajax.reload(null, false);
                    }).fail(function (result) {});
                }
            }
        });

        return false;
    });

    $(document).on('click', '.dataTable[id=orderItemsProcessingTotal] [data-cancel-all-order-items], .dataTable[id=preorderListProduct] [data-cancel-all-order-items]', function (e) {
        e.preventDefault();
        var productId = $(this).attr("data-cancel-all-order-items");
        var customerId = $(this).attr("data-cancel-all-order-items-customerid");
        var table = $(this).closest('.dataTable');
        var msgTxt = Resx.App.CancelAllOrderItemsConfirmMessage.replace("{0}", $(this).attr("data-cancel-all-order-items-name")).replace("{1}", $(this).attr("data-cancel-all-order-items-amount"));
        _message2.default.confirm(msgTxt, Resx.App.CancelOrderItemConfirmTitle, function (isConfirmed) {
            if (isConfirmed) {
                if (table.length > 0) {
                    var api = table.DataTable();
                    orderService.cancelAllOrderItemsByEan(productId, customerId).done(function (result) {
                        api.ajax.reload(null, false);
                    }).fail(function (result) {});
                }
            }
        });

        return false;
    });

    $(document).on('click', '#cancelAllOrderItems', function (e) {
        e.preventDefault();
        var orderId = $(this).attr("data-order-id");
        var table = $('.dataTable[data-table-id="orderItems"]');
        var msgTxt = Resx.App.CancelAllOrderItemsByOrderConfirmMessage;
        orderService.cancellableItemsCountForOrder(orderId).done(function (result) {
            msgTxt = msgTxt.replace("{0}", result);
            _message2.default.confirm(msgTxt, Resx.App.CancelAllOrderItemsByOrderConfirmTitle, function (isConfirmed) {
                if (isConfirmed) {
                    if (table.length > 0) {
                        var api = table.DataTable();
                        orderService.cancelAllOrderItemsByOrder(orderId).done(function (result) {
                            api.ajax.reload(null, false);
                        }).fail(function (result) {});
                    }
                }
            });
        });

        return false;
    });
};

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");
var orderService = abp.services.api.order;

var Resx = (0, _localize2.default)('App');

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/orderActions.js
// module id = 936
// module chunks = 0